import { c as _c } from "react/compiler-runtime";
import { useUser } from "@b3dotfun/sdk/global-account/react";
import type { UserGroupId } from "@/lib/userGroups";

/**
 * Returns true when the current user belongs to any of the given user groups.
 *
 * Pass a module-level `as const` array so the reference is stable across
 * renders (e.g. `const VIP_GROUPS = [UserGroup.VIP, UserGroup.Admin] as const`).
 */
export function useHasUserGroup(groups) {
  const $ = _c(5);
  const {
    user
  } = useUser();
  if (!user) {
    return false;
  }
  const userGroups = (user as {
    userGroups?: unknown;
  })?.userGroups;
  if (!Array.isArray(userGroups)) {
    return false;
  }
  let t0;
  if ($[0] !== groups || $[1] !== userGroups) {
    let t1;
    if ($[3] !== userGroups) {
      t1 = g => userGroups.includes(g);
      $[3] = userGroups;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    t0 = groups.some(t1);
    $[0] = groups;
    $[1] = userGroups;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}